/**
 * The auto-decline confidence threshold as a slider, 50–99%. The value is a fraction (0.80), as
 * the API stores it; the slider works in whole percent. Used by Admin → Settings (platform
 * default), My Company (the client's own) and the client page (super admin override).
 */
export function ThresholdSlider({
  id,
  label,
  value,
  onChange,
  help,
  disabled,
}: {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  help?: string;
  disabled?: boolean;
}) {
  const percent = Math.round(value * 100);
  return (
    <div>
      <label htmlFor={id} className="form-label small fw-semibold d-flex justify-content-between">
        <span>{label}</span>
        <span className="badge badge-status bg-primary-subtle text-primary border border-primary-subtle">{percent}%</span>
      </label>
      <input
        id={id}
        type="range"
        className="form-range"
        min={50}
        max={99}
        step={1}
        value={percent}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
      />
      <div className="d-flex justify-content-between small text-body-secondary">
        <span>50% · more approvals</span>
        <span>99% · stricter</span>
      </div>
      {help && <div className="form-text">{help}</div>}
    </div>
  );
}
